module.exports = __webpack_public_path__ + "static/media/icons_Bilan Guillarme - Algies Pelvi-p‚rin‚o-pudendales.c37c2ac9.svg";